// Vendor
window.$ = window.jQuery = require('jquery');
window.bootstrap = require('bootstrap');
window.Cleave = require('cleave.js/dist/cleave');
window.Dropzone = require('dropzone');
window.moment = require('moment');
window.Popper = require('@popperjs/core');
window.QRCode = require('qrcodejs2');
window.Swal = require('sweetalert2/dist/sweetalert2');

require('bootstrap');
require('datatables.net-bs5');
require('datatables.net-responsive-bs5');
require('daterangepicker');

// Custom Override (Bootstrap 5)
require('./main/modules/input-phone');
require('./main/modules/selection');
require('@veximus/collection');

// Core
require('./utilities');
require('./main/base');
